import img1 from "src/assets/avatars/obi-wan.jpeg";
import img2 from "src/assets/avatars/yoda.jpeg";
import img3 from "src/assets/avatars/veider.jpeg";
import img4 from "src/assets/avatars/walker.jpeg";
import img5 from "src/assets/avatars/luke.jpeg";
import img6 from "src/assets/avatars/han-solo.jpg";
import img7 from "src/assets/avatars/gon.jpeg";
import img8 from "src/assets/avatars/palpatine.jpeg";
import img9 from "src/assets/avatars/general.jpeg";
import img10 from "src/assets/avatars/chew.jpeg";

const authors: any[] = [
    {
        id: 1,
        name: "Obi-Wan Kenobi",
        avatar: img1,
    },
    {
        id: 2,
        name: "Yoda",
        avatar: img2,
    },
    {
        id: 3,
        name: "Darth Vader",
        avatar: img3,
    },
    {
        id: 4,
        name: "Anakin Skywalker",
        avatar: img4,
    },
    {
        id: 5,
        name: "Luke Skywalker",
        avatar: img5,
    },
    {
        id: 6,
        name: "Han Solo",
        avatar: img6,
    },
    {
        id: 7,
        name: "Qui-Gon Jinn",
        avatar: img7,
    },
    {
        id: 8,
        name: "Palpatine",
        avatar: img8,
    },
    {
        id: 9,
        name: "General Grievous",
        avatar: img9,
    },
    {
        id: 10,
        name: "Chewbacca",
        avatar: img10,
    },
];

export default authors;
